// @flow

import accountUpdated from './triggers/account.updated.json';
import balanceAvailable from './triggers/balance.available.json';
import chargeCaptured from './triggers/charge.captured.json';
import chargeDisputeCreated from './triggers/charge.disputed.created.json';
import chargeFailed from './triggers/charge.failed.json';
import chargeRefunded from './triggers/charge.refunded.json';
import chargeSucceeded from './triggers/charge.succeeded.json';
import checkoutSessionAsyncPaymentFailed from './triggers/checkout.session.async_payment_failed.json';
import checkoutSessionAsyncPaymentSucceeded from './triggers/checkout.session.async_payment_succeeded.json';
import checkoutSessionCompleted from './triggers/checkout.session.completed.json';
import customerCreated from './triggers/customer.created.json';
import customerDeleted from './triggers/customer.deleted.json';
import customerUpdated from './triggers/customer.updated.json';
import customerSourceCreated from './triggers/customer.source.created.json';
import customerSourceUpdated from './triggers/customer.source.updated.json';
import customerSubscriptionCreated from './triggers/customer.subscription.created.json';
import customerSubscriptionDeleted from './triggers/customer.subscription.deleted.json';
import customerSubscriptionUpdated from './triggers/customer.subscription.updated.json';
import invoiceCreated from './triggers/invoice.created.json';
import invoiceFinalized from './triggers/invoice.finalized.json';
import invoicePaymentActionRequired from './triggers/invoice.payment_action_required.json';
import invoicePaymentFailed from './triggers/invoice.payment_failed.json';
import invoicePaymentSucceeded from './triggers/invoice.payment_succeeded.json';
import invoiceUpdated from './triggers/invoice.updated.json';
import issuingAuthorizationRequest from './triggers/issuing_authorization.request.json';
import issuingCardCreated from './triggers/issuing_card.created.json';
import issuingCardholderCreated from './triggers/issuing_cardholder.created.json';
import paymentIntentAmountCapturableUpdated from './triggers/payment_intent.amount_capturable_updated.json';
import paymentIntentCreated from './triggers/payment_intent.created.json';
import paymentIntentPaymentFailed from './triggers/payment_intent.payment_failed.json';
import paymentIntentSucceeded from './triggers/payment_intent.succeeded.json';
import paymentIntentCanceled from './triggers/payment_intent.canceled.json';
import paymentMethodAttached from './triggers/payment_method.attached.json';
import payoutCreated from './triggers/payout.created.json';
import payoutUpdated from './triggers/payout.updated.json';
import planCreated from './triggers/plan.created.json';
import planDeleted from './triggers/plan.deleted.json';
import planUpdated from './triggers/plan.updated.json';
import productCreated from './triggers/product.created.json';
import productDeleted from './triggers/product.deleted.json';
import productUpdated from './triggers/product.updated.json';
import setupIntentCanceled from './triggers/setup_intent.canceled.json';
import setupIntentCreated from './triggers/setup_intent.created.json';
import setupIntentSetupFailed from './triggers/setup_intent.setup_failed.json';
import setupIntentSucceeded from './triggers/setup_intent.succeeded.json';
import subscriptionScheduleCanceled from './triggers/subscription_schedule.canceled.json';
import subscriptionScheduleCreated from './triggers/subscription_schedule.created.json';
import subscriptionScheduleReleased from './triggers/subscription_schedule.released.json';
import subscriptionScheduleUpdated from './triggers/subscription_schedule.updated.json';
import subscriptionPaymentFailed from './triggers/subscription.payment_failed.json';
import subscriptionPaymentSucceeded from './triggers/subscription.payment_succeeded.json';
import quoteCreated from './triggers/quote.created.json';
import quoteCanceled from './triggers/quote.canceled.json';
import quoteFinalized from './triggers/quote.finalized.json';
import quoteAccepted from './triggers/quote.accepted.json';

export type FixtureValue = string | number | boolean | null | typeof undefined;
export type FixtureParams =
  | FixtureValue
  | Array<FixtureParams>
  | {[string]: FixtureParams};

export type Fixture = {
  name: string,
  path: string,
  method: string,
  params?: {[string]: FixtureParams},
};

export type FixtureConfig = {
  _meta: {
    template_version: number,
  },
  fixtures: Array<Fixture>,
};

export const TriggerTree: {[event: string]: FixtureConfig} = {
  'account.updated': accountUpdated,
  'balance.available': balanceAvailable,
  'charge.captured': chargeCaptured,
  'charge.dispute.created': chargeDisputeCreated,
  'charge.failed': chargeFailed,
  'charge.refunded': chargeRefunded,
  'charge.succeeded': chargeSucceeded,
  'checkout.session.async_payment_failed': checkoutSessionAsyncPaymentFailed,
  'checkout.session.async_payment_succeeded': checkoutSessionAsyncPaymentSucceeded,
  'checkout.session.completed': checkoutSessionCompleted,
  'customer.created': customerCreated,
  'customer.deleted': customerDeleted,
  'customer.updated': customerUpdated,
  'customer.source.created': customerSourceCreated,
  'customer.source.updated': customerSourceUpdated,
  'customer.subscription.created': customerSubscriptionCreated,
  'customer.subscription.deleted': customerSubscriptionDeleted,
  'customer.subscription.updated': customerSubscriptionUpdated,
  'invoice.created': invoiceCreated,
  'invoice.finalized': invoiceFinalized,
  'invoice.payment_action_required': invoicePaymentActionRequired,
  'invoice.payment_failed': invoicePaymentFailed,
  'invoice.payment_succeeded': invoicePaymentSucceeded,
  'invoice.updated': invoiceUpdated,
  'issuing_authorization.request': issuingAuthorizationRequest,
  'issuing_card.created': issuingCardCreated,
  'issuing_cardholder.created': issuingCardholderCreated,
  'payment_intent.amount_capturable_updated': paymentIntentAmountCapturableUpdated,
  'payment_intent.created': paymentIntentCreated,
  'payment_intent.payment_failed': paymentIntentPaymentFailed,
  'payment_intent.succeeded': paymentIntentSucceeded,
  'payment_intent.canceled': paymentIntentCanceled,
  'payment_method.attached': paymentMethodAttached,
  'payout.created': payoutCreated,
  'payout.updated': payoutUpdated,
  'plan.created': planCreated,
  'plan.deleted': planDeleted,
  'plan.updated': planUpdated,
  'product.created': productCreated,
  'product.deleted': productDeleted,
  'product.updated': productUpdated,
  'setup_intent.canceled': setupIntentCanceled,
  'setup_intent.created': setupIntentCreated,
  'setup_intent.setup_failed': setupIntentSetupFailed,
  'setup_intent.succeeded': setupIntentSucceeded,
  'subscription_schedule.canceled': subscriptionScheduleCanceled,
  'subscription_schedule.created': subscriptionScheduleCreated,
  'subscription_schedule.released': subscriptionScheduleReleased,
  'subscription_schedule.updated': subscriptionScheduleUpdated,
  'subscription.payment_succeeded': subscriptionPaymentSucceeded,
  'subscription.payment_failed': subscriptionPaymentFailed,
  'quote.created': quoteCreated,
  'quote.canceled': quoteCanceled,
  'quote.finalized': quoteFinalized,
  'quote.accepted': quoteAccepted,
};
